module.exports = __webpack_public_path__ + "static/media/sdk-2.6d14780e.svg";